import { action, computed, observable } from "mobx";
import { debounce } from "lodash";
import { BaseStore } from "@store/BaseStore";
import { store } from "@store";
import { ObservableSubscription } from "@apollo/client";
import {
  AccommodationEventLog_AddComment as addComment,
  AccommodationEventLog_GetEvents as getEvents,
  AccommodationEventLog_Update as updateEvent,
  AccommodationEventType,
  EventLog_AccommodationEventFragment as Event
} from "@graphql";
import { CommentBoxData } from "../CommentBox/CommentBoxStore";
import { ReminderFormData } from "@containers/ReminderDialog/ReminderStore";

export class AccommodationEventLogStore extends BaseStore {
  @computed get events() {
    return this._events.filter((ev) => !ev.Deleted);
  }

  @observable eventTypeFilter: AccommodationEventType[] = [];

  private query = getEvents.funcWatch(
    { accommodationId: this.accommodationId },
    {
      fetchPolicy: "network-only"
    }
  );

  private queryVars: getEvents.Variables;
  private subscription: ObservableSubscription;

  @observable private _events: Event[] = [];

  private refetch = debounce(() => this.query.refetch(this.queryVars), 200);

  constructor(private accommodationId: string) {
    super();
    this.subscribe();
  }

  subscribe() {
    const { snackbars } = store();

    this.subscription = this.query.subscribe({
      next: ({ data, loading }) => {
        if (loading) {
          this.setLoading();
        }

        this._events = data.accommodationEvents;

        this.setReady();
      },

      error: (e) => snackbars.error(`Cannot get events\nReason: ${e}`)
    });
  }

  unsubscribe() {
    this.subscription && this.subscription.unsubscribe();
  }

  @action.bound addComment(data: CommentBoxData, reminder?: ReminderFormData) {
    return addComment
      .func({
        accommodationId: this.accommodationId,
        desc: data.text,
        withTodo: reminder
      })
      .then(() => this.refetch())
      .catch((e) => store().snackbars.error(`Error occurred: ${e}`));
  }

  @action.bound setEventTypeFilter(value: []) {
    this.eventTypeFilter = value;
  }

  updateEvent = (eventId: string, desc: string) => {
    return updateEvent
      .func({ eventId, desc })
      .then(() => this.refetch())
      .catch((err) => {
        store().snackbars.error(`Cannot update event\nReason: ${err}`);
      });
  };
}
